import { ToastOptions } from "react-toastify";

// Toast Messages
export const toastMessages = {
  trainingSaved: "Trening zapisany.",
  trainingDeleted: "Trening usunięty.",
  trainingSaveError: "Błąd podczas zapisu treningu.",
  trainingDeleteError: "Błąd podczas usuwania treningu.",
  trainingPeriodSaved: "Okres treningowy zapisany pomyślnie.",
  trainingPeriodUpdated: "Okres treningowy zaktualizowany pomyślnie.",
  trainingPeriodDeleted: "Okres treningowy usunięty pomyślnie.",
  trainingPeriodSaveError: "Nie udało się zapisać okresu treningowego.",
  trainingPeriodUpdateError: "Nie udało się zaktualizować okresu treningowego.",
  trainingPeriodDeleteError: "Nie udało się usunąć okresu treningowego.",
  trainingPeriodLoadError: "Nie udało się załadować okresu treningowego.",
  trainingPeriodLoaded: "Okres treningowy załadowany pomyślnie.",
};

// Toast Titles
export const toastrTitles = {
  success: "Sukces",
  error: "Błąd",
};

// Default Toast Options
export const toastOptions: ToastOptions = {
  position: "top-right", // Position of the toast
  autoClose: 1000, // Close after 1 second
  hideProgressBar: false, // Show progress bar
  closeOnClick: true, // Dismiss toast on click
  pauseOnHover: true, // Pause toast timer on hover
  draggable: true, // Allow drag to dismiss
  theme: "colored", // Use colored theme
};
